import api from '..';
import useResourceList from './useResourceList';
import useQuery from './useQuery';

export const useMediaTagList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'mediaTags', api: api.mediaTags }, queryVariables, queryConfig);

  return {
    mediaTags: queryResult.resolvedData,
    latestMediaTags: queryResult.latestData,
    ...queryResult,
  };
};

export const useMediaTag = (id, queryConfig = {}) => {
  const queryResult = useQuery(['mediaTag', { id }], api.mediaTags.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    mediaTag: queryResult.data || {},
    ...queryResult,
  };
};
